module.exports = __webpack_public_path__ + "fonts/Jost-200-Thin.10595a1.otf";